import { render, staticRenderFns } from "./TagEdit.vue?vue&type=template&id=61a04eb6&scoped=true&"
import script from "./TagEdit.vue?vue&type=script&lang=js&"
export * from "./TagEdit.vue?vue&type=script&lang=js&"
import style0 from "./TagEdit.vue?vue&type=style&index=0&id=61a04eb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a04eb6",
  null
  
)

export default component.exports